module.exports = "/_next/static/images/Introduction@2x-09a44a0dab4c258ea746487fcaacd975.webp";